import { KeyGroup } from '@libs/types/enum'
import { DevicePid } from './define'

export const DevicesSwitchOfHupo = [DevicePid.IROKNd63]

export const DevicesSwitchOfTianqing_SE = [DevicePid.IROKMg68SE, DevicePid.CarotmasMars68SE]

export const DevicesSwitchOfTianqing = [DevicePid.IROKNd63_cyan]

export const DevicesSwitchOfTianqing_Pro = [
  DevicePid.IYXMu68Pro,
  DevicePid.IYXMu68Pro_cyan,

  DevicePid.IROKMg75,
  DevicePid.IROKMg68,
  DevicePid.IROKMg68LITE,

  DevicePid.CarotmasMars68,
  DevicePid.CarotmasMars68_Wireless,
  DevicePid.CarotmasMars68_Wireless_24g,

  DevicePid.CarotmasMer68SE_JT,
]

export const DevicesSwitchOfZixin = [
  DevicePid.IYXMu68_ULTRA,

  DevicePid.CarotmasMars68Pro,
  DevicePid.CarotmasMars68Pro_Wireless,
  DevicePid.CarotmasMars68Pro_Wireless_24g,

  DevicePid.IROKMg68Max,
  DevicePid.IROKMg68Max_24g,
  DevicePid.IROKMg68Pro,
  DevicePid.IROKMG68ACE,
  DevicePid.IROKMG68ACE_W,
  DevicePid.IROKMG68ACE_W_24g,

  DevicePid.CarotmasMer68,
  DevicePid.IROKND63Max,
  DevicePid.CarotmasMars75,
  DevicePid.IROKND68,
]

export const DevicesSwitchOfWanciwang = [DevicePid.IYXPolar75]

export const DevicesSwitchOfXingguang = [DevicePid.IROKND63Ultra, DevicePid.IROKND68Pro, DevicePid.CarotmasMars75Pro, DevicePid.CarotmasMer68Max, DevicePid.CarotmasMer68Pro]

export const DevicesSwitchOfQinghui = [DevicePid.IROKMg75Max, DevicePid.IROKRA68]

export const DevicesSwitchOfQinghuiPro = [DevicePid.IROKMG75V2C12, DevicePid.IROKMG63, DevicePid.IROKRA68_1]

export const DevicesSwitchOfDefault = [DevicePid.IROKNa87Pro, DevicePid.IROKMG68ACE_UpPlus, DevicePid.IROKMg75PRO, DevicePid.IROKMg68Plus, DevicePid.CarotmasMer68Lite]

export const DevicesSwitchOfUnknown: DevicePid[] = []

const defaultAxis = KeyGroup.cipo
const deviceAxis: Map<DevicePid, KeyGroup> = new Map()
DevicesSwitchOfTianqing.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.tianqing))
DevicesSwitchOfTianqing_Pro.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.tianqing_Pro))
DevicesSwitchOfTianqing_SE.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.tianqing_SE))

DevicesSwitchOfDefault.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.cipo))
DevicesSwitchOfZixin.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.zixing))
DevicesSwitchOfWanciwang.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.wanciwang))
DevicesSwitchOfXingguang.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.xingguang))
DevicesSwitchOfQinghui.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.qinghui))
DevicesSwitchOfQinghuiPro.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.qinghui_pro))

DevicesSwitchOfUnknown.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.unknown))
DevicesSwitchOfHupo.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.Hupo))

export const getCurrentDeviceAxis = (keyGroup: DevicePid): KeyGroup => {
  return deviceAxis.get(keyGroup) || defaultAxis
}
